/* global Foundation */

import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
let targetElement = document.querySelector( '.chr-black-overlay' );

const $body = $( 'body' );
const $window = $( window );
const navScrollDistance = 0;
const LARGE = 1279;

// Search Form Element
const $searchToggleBtn = jQuery( '#chr-search-toggle-button' );
const $searchForm = jQuery( '.chr-search-form-wrapper' );

const $hamburger = jQuery( '.chr-hamburger' );
const $mainMenu = jQuery( '.chr-header-menus' );

// Flags
const $flagSelector = jQuery( '.region-selector' );

const $whiteOverlay = jQuery( '.chr-white-overlay' );

const scrollHeader = () => {

  let st = jQuery( window ).scrollTop();
  if ( st > navScrollDistance ) {
    $body.addClass( 'scroll' );
  } else {
    $body.removeClass( 'scroll' );
  }

};

// Toggle Menus
const closeRegionSelector = () => {
  $body.removeClass( 'show-flag-dropdown' );
};

const OpenSearchForm = () => {
  $searchToggleBtn.addClass( 'close' );
  $body.addClass( 'search-form-open' );
  $whiteOverlay.fadeIn();
  targetElement = document.querySelector( '.chr-search-form-wrapper' );
  disableBodyScroll( targetElement );
};

const CloseSearchForm = () => {
  $searchToggleBtn.removeClass( 'close' );
  $body.removeClass( 'search-form-open' );
  $whiteOverlay.fadeOut();
  enableBodyScroll( targetElement );
};

const OpenResponsiveMainMenu = () => {
  $mainMenu.addClass( 'menu-open' );
  $hamburger.attr( 'aria-expanded', 'true' );

  targetElement = document.querySelector( '.chr-main-menu' );
  disableBodyScroll( targetElement );
  $( 'html' ).css( 'overflow', 'hidden' );
};

const CloseResponsiveMainMenu = () => {
  $mainMenu.removeClass( 'menu-open' );
  $hamburger.attr( 'aria-expanded', 'false' );

  enableBodyScroll( targetElement );
  $( 'html' ).css( 'overflow', 'auto' );
};

// Actions

const toggleSearchFormAction = () => {

  if ( ! $searchToggleBtn.length ) {
    return;
  }

  $searchToggleBtn.click( () => {
    closeRegionSelector();
    CloseResponsiveMainMenu();

    if ( $searchToggleBtn.hasClass( 'close' ) ) {
      if ( window.innerWidth > LARGE &&
        $searchForm.find( 'input[type="text"]' ).val().trim() !== '' ) {
        $searchForm.find( 'input[type="submit"]' ).click();
      } else {
        CloseSearchForm();
        $whiteOverlay.fadeOut();
      }
    } else {
      CloseResponsiveMainMenu();
      OpenSearchForm();
      $whiteOverlay.fadeIn();
    }

  });

};

const toggleResponsiveMainMenuAction = () => {

  $hamburger.click( () => {
    closeRegionSelector();
    CloseSearchForm();

    if ( Foundation.MediaQuery.is( 'large' ) ) {
      return;
    }

    if ( $hamburger.hasClass( 'open' ) ) {
      CloseResponsiveMainMenu();
      $whiteOverlay.fadeOut();
      $hamburger.removeClass( 'open' );
    } else {
      CloseSearchForm();
      OpenResponsiveMainMenu();
      $whiteOverlay.fadeIn();
      $hamburger.addClass( 'open' );
    }

  });

};

const toggleRegionSelector = () => {

  $flagSelector.on( 'click', function() {

    CloseSearchForm();
    CloseResponsiveMainMenu();
    let targetElement = document.querySelector( '.region-selector' );

    $body.toggleClass( 'show-flag-dropdown' );

    if ( $body.hasClass( 'show-flag-dropdown' ) ) {
      $whiteOverlay.fadeIn();
      disableBodyScroll( targetElement );
    } else {
      $whiteOverlay.fadeOut();
      enableBodyScroll( targetElement );
    }

  });
};

const closeAll = () => {

  $whiteOverlay.click( () => {
    CloseSearchForm();
    CloseResponsiveMainMenu();
    closeRegionSelector();
    clearAllBodyScrollLocks();
    $whiteOverlay.fadeOut();
  });

};

$( document ).ready( () => {

  toggleSearchFormAction();
  toggleResponsiveMainMenuAction();
  toggleRegionSelector();

  closeAll();

  /*Handle some scroll events*/
  $window.scroll( () => {

    scrollHeader();

  }).scroll();

});
